function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #1d1d1d;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-253 -244)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  className: "cls-1",
  width: 21,
  height: 21,
  transform: "translate(253 244)"
}), /*#__PURE__*/React.createElement("g", {
  id: "angle-left",
  transform: "translate(366.54 264.5) rotate(180)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  className: "cls-2",
  d: "M108.129,10.99l-8.6,8.6a1.4,1.4,0,1,1-1.981-1.98l7.61-7.61L97.549,2.391A1.4,1.4,0,0,1,99.53.41l8.6,8.6a1.4,1.4,0,0,1,0,1.98Z"
})));

var SvgAngleLeft = function SvgAngleLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAngleLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/angle-left.05384e06.svg";
export { ForwardRef as ReactComponent };